module.exports = __webpack_public_path__ + "static/media/KeeperSVG.02458bda.svg";